import React, { useState, useEffect } from "react";
import {
    Slider,
    InputNumber,
    Button,
    Row,
    Col,
    Card,
    Typography,
    Select,
} from "antd";
import {  ArrowLeftOutlined } from "@ant-design/icons";
import { CalculatorOutlined, CloseOutlined, RedoOutlined } from '@ant-design/icons';
import { calculateCapacity } from "../../../apis";
import "../../../styles/components/modals.css";
const { Title } = Typography;
const { Option } = Select;

const CapsatModal = ({ onClose, setCapacita, isNewManovra, setCapSatResult }) => {
    const [step, setStep] = useState(2);
    const [maneuverConfigs, setManeuverConfigs] = useState([]);
    const [laneTypes, setLaneTypes] = useState([]);
    const [advancedConfigs, setAdvancedConfigs] = useState([]);
    const [buttonClicked, setButtonClicked] = useState(false);
    const [calculationResult, setCalculationResult] = useState([]);
    const [logMessaggi, setLogMessaggi] = useState([]);

    const resetWizard = () => {
        setStep(2);
        setManeuverConfigs([
            { id: 1, numCorsie: 1, presenzaParcheggi: "no", presenzaFermateBus: "no" }
        ]);
        setLaneTypes([]);
        setAdvancedConfigs([]);
        setButtonClicked(false);
        setCalculationResult([]);
    };

    const isValidAdvancedConfig = (config) => {
        const hasSxPrecedenza = config.tipoCorsie.includes("solo_sx_dare_precedenza");
        const hasDrittoSx = config.tipoCorsie.includes("dritto/sx");
        const hasDrittoDxSx = config.tipoCorsie.includes("dritto/dx/sx");

        if ((hasSxPrecedenza || hasDrittoSx || hasDrittoDxSx) && config.flussoDirezioneOpposta <= 0) {
            return false;
        }

        if (hasDrittoDxSx) {
            const percSx = config.percentualeSvoltaSX || 0;
            const percDx = config.percentualeSvoltaDX || 0;
            if ((percSx + percDx) > 100) {
                return false;
            }
        }

        return true;
    };

    const isValidConfiguration = () => {
        return advancedConfigs.every(cfg => isValidAdvancedConfig(cfg));
    };

    useEffect(() => {
        if (isNewManovra) {
            resetWizard();
        }
    }, [isNewManovra]);

    const handleConfirmBaseData = () => {
        const newLaneTypes = maneuverConfigs.map((m) => ({
            id: m.id,
            corsie: Array.from({ length: m.numCorsie }, () => "solo_dritto"),
        }));
        setLaneTypes(newLaneTypes);
        setStep(3);
    };

    const handleConfirmLaneTypes = () => {
        const advanced = maneuverConfigs.map((m, index) => ({
            id: m.id,
            capBasePerCorsia: 1200,
            larghezzaCorsia: 3.5,
            percVeicoliPesanti: 0,
            pendenza: 0,
            sensoUnicoODoppio: m.presenzaParcheggi === "si" ? "unico" : null,
            durataParcheggio: m.presenzaParcheggi === "si" ? "1" : null,
            frequenzaFermataBus: m.presenzaFermateBus === "si" ? 0 : null,
            tipoCorsie: laneTypes[index].corsie,
            flussoDirezioneOpposta: 0,
            percentualeSvoltaSX: 0,
            percentualeSvoltaSXFlussoOpposto: 0,
            durataVerdeEfficace: 1,
            durataVerdeNonInConflitto: 0,
            tempoPrimaDiSvoltaSX: 0,
            percentualeSvoltaDX: 0,
        }));
        setAdvancedConfigs(advanced);
        setStep(4);
    };

    const updateLaneType = (maneuverIndex, laneIndex, value) => {
        const newLaneTypes = [...laneTypes];
        newLaneTypes[maneuverIndex].corsie[laneIndex] = value;
        setLaneTypes(newLaneTypes);
    };

    const handleAdvancedInputChange = (index, field, value) => {
        const updatedConfigs = [...advancedConfigs];
        updatedConfigs[index][field] = value;
        setAdvancedConfigs(updatedConfigs);
    };

    const handleCalculate = async () => {
        try {
            setButtonClicked(true);
            const presenzaParcheggi = maneuverConfigs.map((m) => m.presenzaParcheggi);
            const presenzaFermateBus = maneuverConfigs.map((m) => m.presenzaFermateBus);
            const parametriManovre = advancedConfigs.map((config, index) => ({
                num_corsie: config.tipoCorsie.length,
                cap_base_per_corsia: config.capBasePerCorsia,
                larghezza_corsia: config.larghezzaCorsia,
                perc_veicoli_pesanti: config.percVeicoliPesanti,
                pendenza: config.pendenza,
                tipo_manovra: config.tipoCorsie,
                senso_unico_o_doppio: config.sensoUnicoODoppio,
                durata_parcheggio: config.durataParcheggio,
                frequenza_fermata_bus: config.frequenzaFermataBus,
                flusso_direzione_opposta: config.flussoDirezioneOpposta,
                "%_svolta_sx": config.percentualeSvoltaSX,
                "%_svolta_sx_flusso_opposto": config.percentualeSvoltaSXFlussoOpposto,
                durata_verde_efficace: config.durataVerdeEfficace,
                durata_verde_non_in_conflitto: config.durataVerdeNonInConflitto,
                tempo_prima_di_svolta_sx: config.tempoPrimaDiSvoltaSX,
                "%_svolta_dx": config.percentualeSvoltaDX,
            }));

            const data = await calculateCapacity({
                parametri_manovre: parametriManovre,
                presenza_parcheggi: presenzaParcheggi,
                presenza_fermate_bus: presenzaFermateBus,
            });

            if (data.errors && data.errors.length > 0) {
                console.warn("⚠️ Messaggi dal backend:", data.errors);
                setLogMessaggi(data.errors);
            } else {
                setLogMessaggi([]);
            }

            setCalculationResult(data || []);
            const totale = (data.result || []).reduce((sum, val) => sum + Number(val || 0), 0);
            setCapacita(totale);
            setCapSatResult(data?.length ? data[0] : 0);
        } catch (error) {
            console.error("Errore nella chiamata API:", error);
            alert("Si è verificato un errore nella chiamata API");
        }
    };

    const handleBack = () => {
        if (step === 3) {
            setStep(2);
        } else if (step === 4) {
            setStep(3);
        }
    };

    return (
        <div className="capsat-modal-container">
            <div className="capsat-modal-header">
                <Title level={2} className="capsat-modal-title">
                    Calcola Capacità
                </Title>
   
            </div>

            {step >= 2 && (
                <Card className="capsat-modal-card">
                    <div className="capsat-section-header">
                        <Title level={3} className="capsat-section-title">Configura le manovre</Title>
                        {step > 2 && (
                            <Button 
                                type="text" 
                                icon={<ArrowLeftOutlined />} 
                                onClick={handleBack}
                                className="capsat-back-button"
                            >
                                Indietro
                            </Button>
                        )}
                    </div>
                    <Row gutter={[16, 16]}>
                        {maneuverConfigs.map((man, index) => (
                            <Col span={24} key={man.id}>
                                <Card
                                    title={`Manovra ${man.id}`}
                                    size="small"
                                    className="capsat-maneuver-card"
                                >
                                    <Row gutter={16} align="middle">
                                        <Col xs={24} sm={12} md={12} lg={10} className="capsat-maneuver-row">
                                            <span className="capsat-maneuver-label">Numero Corsie:</span>
                                            <div className="capsat-input-container">
                                                <Slider
                                                    min={1}
                                                    max={5}
                                                    value={man.numCorsie}
                                                    onChange={(val) => {
                                                        const updated = [...maneuverConfigs];
                                                        updated[index].numCorsie = val;
                                                        setManeuverConfigs(updated);
                                                    }}
                                                    className="capsat-slider"
                                                />
                                                <InputNumber
                                                    min={1}
                                                    max={5}
                                                    value={man.numCorsie}
                                                    onChange={(val) => {
                                                        const updated = [...maneuverConfigs];
                                                        updated[index].numCorsie = val;
                                                        setManeuverConfigs(updated);
                                                    }}
                                                    className="capsat-input-number"
                                                />
                                            </div>
                                        </Col>

                                        <Col xs={24} sm={6} md={6} lg={4} className="capsat-maneuver-row">
                                            <span className="capsat-maneuver-label">Parcheggi:</span>
                                            <Select
                                                value={man.presenzaParcheggi}
                                                onChange={(val) => {
                                                    const updated = [...maneuverConfigs];
                                                    updated[index].presenzaParcheggi = val;
                                                    setManeuverConfigs(updated);
                                                }}
                                                className="capsat-select"
                                            >
                                                <Option value="no">No</Option>
                                                <Option value="si">Sì</Option>
                                            </Select>
                                        </Col>

                                        <Col xs={24} sm={6} md={6} lg={4} className="capsat-maneuver-row">
                                            <span className="capsat-maneuver-label">Fermate Bus:</span>
                                            <Select
                                                value={man.presenzaFermateBus}
                                                onChange={(val) => {
                                                    const updated = [...maneuverConfigs];
                                                    updated[index].presenzaFermateBus = val;
                                                    setManeuverConfigs(updated);
                                                }}
                                                className="capsat-select"
                                            >
                                                <Option value="no">No</Option>
                                                <Option value="si">Sì</Option>
                                            </Select>
                                        </Col>
                                    </Row>
                                </Card>
                            </Col>
                        ))}
                    </Row>

                    <Button
                        onClick={handleConfirmBaseData}
                        disabled={step !== 2}
                        className="capsat-confirm-button"
                    >
                        Conferma manovre
                    </Button>
                </Card>
            )}

            {step >= 3 && (
                <Card className="capsat-modal-card">
                    <div className="capsat-section-header">
                        <Title level={3} className="capsat-section-title">Definisci Tipo di Corsia</Title>
                        {step > 3 && (
                            <Button 
                                type="text" 
                                icon={<ArrowLeftOutlined />} 
                                onClick={handleBack}
                                className="capsat-back-button"
                            >
                                Indietro
                            </Button>
                        )}
                    </div>
                    {laneTypes.map((maneuver, mIndex) => (
                        <Card
                            key={maneuver.id}
                            title={`Manovra ${maneuver.id}`}
                            className="capsat-maneuver-card"
                        >
                            <Row gutter={[16, 16]}>
                                {maneuver.corsie.map((laneType, laneIndex) => (
                                    <Col xs={24} sm={12} md={6} lg={6} key={laneIndex}>
                                        <span className="capsat-lane-type-label">
                                            Tipo Corsia {laneIndex + 1}:
                                        </span>
                                        <Select
                                            value={laneType}
                                            className="capsat-lane-select"
                                            onChange={(value) =>
                                                updateLaneType(mIndex, laneIndex, value)
                                            }
                                        >
                                            <Option value="solo_dritto">Solo Dritto</Option>
                                            <Option value="solo_dx">Solo Destra</Option>
                                            <Option value="solo_sx_con_precedenza">
                                                Solo Sinistra con Precedenza
                                            </Option>
                                            <Option value="solo_sx_dare_precedenza">
                                                Solo Sinistra Dare Precedenza
                                            </Option>
                                            <Option value="dritto/sx">Dritto/Sinistra</Option>
                                            <Option value="dritto/dx">Dritto/Destra</Option>
                                            <Option value="dritto/dx/sx">Dritto/Destra/Sinistra</Option>
                                        </Select>
                                    </Col>
                                ))}
                            </Row>
                        </Card>
                    ))}

                    <Button
                        onClick={handleConfirmLaneTypes}
                        disabled={step !== 3}
                        className="capsat-confirm-button"
                    >
                        Conferma Tipo di Corsie
                    </Button>
                </Card>
            )}

            {step === 4 && (
                <Card className="capsat-modal-card">
                    <div className="capsat-section-header">
                        <Title level={4} className="capsat-section-title">Configura Parametri Avanzati</Title>
                        <Button 
                            type="text" 
                            icon={<ArrowLeftOutlined />} 
                            onClick={handleBack}
                            className="capsat-back-button"
                        >
                            Indietro
                        </Button>
                    </div>

                    {advancedConfigs.map((config, index) => {
                        const hasSoloSxDarePrecedenza = config.tipoCorsie.includes("solo_sx_dare_precedenza");
                        const hasDrittoSx = config.tipoCorsie.includes("dritto/sx");
                        const hasDrittoDx = config.tipoCorsie.includes("dritto/dx");
                        const hasDrittoDxSx = config.tipoCorsie.includes("dritto/dx/sx");

                        return (
                            <Card
                                key={config.id}
                                size="small"
                                title={`Manovra ${config.id}`}
                                className="capsat-maneuver-card"
                            >
                                <Row gutter={[16, 16]}>
                                    <Col xs={24} sm={12}>
                                        <span>Capacità Base per Corsia (veicoli/ora):</span>
                                        <InputNumber
                                            value={config.capBasePerCorsia}
                                            onChange={(val) =>
                                                handleAdvancedInputChange(index, "capBasePerCorsia", val)
                                            }
                                            className="capsat-advanced-input"
                                        />
                                    </Col>

                                    <Col xs={24} sm={12}>
                                        <span>Larghezza Corsia (metri):</span>
                                        <InputNumber
                                            value={config.larghezzaCorsia}
                                            onChange={(val) =>
                                                handleAdvancedInputChange(index, "larghezzaCorsia", val)
                                            }
                                            className="capsat-advanced-input"
                                        />
                                    </Col>


                                    <Col xs={24} sm={12}>
                                        <span>Percentuale Veicoli Pesanti (%):</span>
                                        <InputNumber
                                            value={config.percVeicoliPesanti}
                                            onChange={(val) =>
                                                handleAdvancedInputChange(index, "percVeicoliPesanti", val)
                                            }
                                            className="capsat-advanced-input"
                                        />
                                    </Col>

                                    <Col xs={24} sm={12}>
                                        <span>Pendenza (%):</span>
                                        <InputNumber
                                            value={config.pendenza}
                                            onChange={(val) =>
                                                handleAdvancedInputChange(index, "pendenza", val)
                                            }
                                            className="capsat-advanced-input"
                                        />
                                    </Col>

                                    {config.sensoUnicoODoppio && (
                                        <>
                                            <Col xs={24} sm={12}>
                                                <span>Senso Unico o Doppio:</span>
                                                <Select
                                                    value={config.sensoUnicoODoppio}
                                                    onChange={(val) =>
                                                        handleAdvancedInputChange(index, "sensoUnicoODoppio", val)
                                                    }
                                                    className="capsat-advanced-select"
                                                >
                                                    <Option value="unico">Unico</Option>
                                                    <Option value="doppio">Doppio</Option>
                                                </Select>
                                            </Col>

                                            <Col xs={24} sm={12}>
                                                <span>Durata Parcheggio (ore):</span>
                                                <Select
                                                    value={config.durataParcheggio}
                                                    onChange={(val) =>
                                                        handleAdvancedInputChange(index, "durataParcheggio", val)
                                                    }
                                                    className="capsat-advanced-select"
                                                >
                                                    <Option value="1">1</Option>
                                                    <Option value="2">2</Option>
                                                </Select>
                                            </Col>
                                        </>
                                    )}

                                    {config.frequenzaFermataBus !== null && (
                                        <Col xs={24} sm={12}>
                                            <span>Frequenza Fermata Bus (bus/ora):</span>
                                            <InputNumber
                                                value={config.frequenzaFermataBus}
                                                onChange={(val) =>
                                                    handleAdvancedInputChange(index, "frequenzaFermataBus", val)
                                                }
                                                className="capsat-advanced-input"
                                            />
                                        </Col>
                                    )}

                                    {(hasSoloSxDarePrecedenza || hasDrittoSx || hasDrittoDxSx) && (
                                        <Col xs={24} sm={12}>
                                            <span>Flusso Direzione Opposta (veicoli/ora):</span>
                                            <InputNumber
                                                value={config.flussoDirezioneOpposta || 0}
                                                onChange={(val) =>
                                                    handleAdvancedInputChange(index, "flussoDirezioneOpposta", val)
                                                }
                                                className="capsat-advanced-input"
                                            />
                                        </Col>
                                    )}

                                    {(hasDrittoSx || hasDrittoDxSx) && (
                                        <>
                                            <Col xs={24} sm={12}>
                                                <span>Veicoli che Svoltano a SX (%):</span>
                                                <InputNumber
                                                    value={config.percentualeSvoltaSX || 0}
                                                    onChange={(val) =>
                                                        handleAdvancedInputChange(index, "percentualeSvoltaSX", val)
                                                    }
                                                    className="capsat-advanced-input"
                                                />
                                            </Col>

                                            <Col xs={24} sm={12}>
                                                <span>Veicoli che Svoltano a SX nel Flusso Opposto (%):</span>
                                                <InputNumber
                                                    value={config.percentualeSvoltaSXFlussoOpposto || 0}
                                                    onChange={(val) =>
                                                        handleAdvancedInputChange(index, "percentualeSvoltaSXFlussoOpposto", val)
                                                    }
                                                    className="capsat-advanced-input"
                                                />
                                            </Col>

                                            <Col xs={24} sm={12}>
                                                <span>Durata Verde Efficace (s):</span>
                                                <InputNumber
                                                    value={config.durataVerdeEfficace || 1}
                                                    onChange={(val) =>
                                                        handleAdvancedInputChange(index, "durataVerdeEfficace", val)
                                                    }
                                                    className="capsat-advanced-input"
                                                />
                                            </Col>

                                            <Col xs={24} sm={12}>
                                                <span>Durata Verde non in Conflitto (s):</span>
                                                <InputNumber
                                                    value={config.durataVerdeNonInConflitto || 0}
                                                    onChange={(val) =>
                                                        handleAdvancedInputChange(index, "durataVerdeNonInConflitto", val)
                                                    }
                                                    className="capsat-advanced-input"
                                                />
                                            </Col>

                                            <Col xs={24} sm={12}>
                                                <span>Tempo Prima di Svolta a SX (s):</span>
                                                <InputNumber
                                                    value={config.tempoPrimaDiSvoltaSX || 0}
                                                    onChange={(val) =>
                                                        handleAdvancedInputChange(index, "tempoPrimaDiSvoltaSX", val)
                                                    }
                                                    className="capsat-advanced-input"
                                                />
                                            </Col>
                                        </>
                                    )}

                                    {(hasDrittoDx || hasDrittoDxSx) && (
                                        <Col xs={24} sm={12}>
                                            <span>Veicoli che Svoltano a DX (%):</span>
                                            <InputNumber
                                                value={config.percentualeSvoltaDX || 0}
                                                onChange={(val) =>
                                                    handleAdvancedInputChange(index, "percentualeSvoltaDX", val)
                                                }
                                                className="capsat-advanced-input"
                                            />
                                        </Col>
                                    )}
                                </Row>
                                {!isValidAdvancedConfig(config) && (
                                    <p className="capsat-validation-error">
                                        ⚠️ Dati incompleti: assicurati di aver inserito un valore positivo per il Flusso Direzione Opposta
                                        {hasDrittoDxSx && " e che la somma delle svolte a SX e DX non superi il 100%"}
                                    </p>
                                )}
                            </Card>
                        );
                    })}
                    <Button
                        onClick={handleCalculate}
                        className="capsat-calculate-button"
                        disabled={buttonClicked || !isValidConfiguration()}
                    >
                        Calcola Capacità
                    </Button>



                    <Title level={5} className="capsat-results-title">Risultati:</Title>
                    {calculationResult.length > 0 ? (
                        calculationResult.map((cap, idx) => (
                            <p key={idx} className="capsat-results-content">
                                <strong>Manovra {idx + 1}:</strong> {cap} veicoli/ora
                            </p>
                        ))
                    ) : (
                        <p className="capsat-results-content">Nessun risultato ancora.</p>
                    )}

                    <Title level={5} className="capsat-messages-title">Messaggi:</Title>

                    {logMessaggi.length > 0 ? (
                        logMessaggi.map((msg, idx) => (
                            <p key={idx} className="capsat-warning-message">{msg}</p>
                        ))
                    ) : (
                        <p className="capsat-no-message">Nessun messaggio di errore.</p>
                    )}

                </Card>

            )}
 <div className="capsat-footer-actions">
  {/* Left-side buttons: Ricalcola and Reset */}
  <div className="capsat-footer-left">
    <Button
      onClick={() => {
        setButtonClicked(false);
        setCalculationResult([]);
        setLogMessaggi([]);
      }}
      className="capsat-recalculate-button"
    >
      <CalculatorOutlined style={{ marginRight: "8px" }} />
      Ricalcola
    </Button>

    <Button
      danger
      onClick={resetWizard}
      className="capsat-reset-button"
    >
      <RedoOutlined style={{ marginRight: "8px" }} />
      Reset
    </Button>
  </div>

  {/* Right-side Chuidi button */}
  <Button
    type="primary"
    onClick={onClose}
    className="capsat-close-button"
  >
    <CloseOutlined style={{ marginRight: "8px" }} />
    Chuidi
  </Button>
</div>
        </div>
    );
};

export default CapsatModal;